(ns kyber.lib.pdftron.hotkeys
  (:require [re-frame.core :as re-frame]))

(defn- override-escape [options {:keys [hotkeys close-elements element-open?]}]
  ;; https://github.com/PDFTron/webviewer-ui/blob/
  ;; 49f157941096afbc33495b68c29dd1a415b23ee9/src/helpers/hotkeysManager.js#L309
  (js-invoke hotkeys "off" "escape")
  (js-invoke hotkeys "on" "escape"
             (fn [e]
               (js-invoke e "preventDefault")
               (when (element-open? "searchPanel")
                 (re-frame/dispatch [:pdftron-viewer/toggle-search options]))

               (close-elements #js ["annotationPopup"
                                    "textPopup"
                                    "contextMenuPopup"
                                    "toolStylePopup"
                                    "annotationStylePopup"
                                    "signatureModal"
                                    "printModal"
                                    "searchOverlay"
                                    "stampOverlay"]))))

(defn set-hotkeys! [options apis]
  (override-escape options apis))
